export const userStatus = {
    1: 'Active',
    2: 'Inactive',
    3: 'Pending',
};